@if (time) {
  {{time.hours | number:'2.0-0'}}:{{time.minutes | number:'2.0-0'}} Uhr
}
